import { makeStyles } from '@/ui/kit/styles/makeStyles';
import type { IconButtonProps as MuiIconButtonProps } from '@mui/material';
import { IconButton as MuiIconButton } from '@mui/material';
import type { FC } from 'react';
import { forwardRef } from 'react';
export interface IconButtonProps extends MuiIconButtonProps {
  variant?: 'simple' | 'round' | 'transparent';
}
const useStyles = makeStyles()(() => ({
  round: {
    borderRadius: '50%',
    backgroundColor: 'transparent'
  },
  transparent: {
    backgroundColor: 'transparent'
  }
}));
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton({
  variant = 'simple',
  className,
  ...restProps
}, ref) {
  const {
    classes,
    cx
  } = useStyles();
  return <MuiIconButton ref={ref} className={cx(className, {
    [classes.round]: variant === 'round',
    [classes.transparent]: variant === 'transparent'
  })} {...restProps} />;
});